import React, { useState, useEffect } from 'react';
import { dateFormatConDiaShort } from '../../../../../utils/DateFunctions';

const ContenedorDeCama = (p) => {
    const cama = p.cama ?? [];
    const index = p.index;
    const clase = () => {
        if (cama.length > 0) return 'bw p-0 round-s m-1 shadow-sm scale-05 border border-2 border-danger bg-dark text-white pointer contenedor';
        return 'bw round-s m-1 p-0 shadow-sm scale-025 border border-2 bg-white contenedor';
    }

    const obtenerIndiceFecha = (masReciente) => {
        let fechas = cama.map((bloque) => { return masReciente ? bloque.fecha_fin : bloque.fecha_inicio });

        if (fechas.length === 0) return '';
        let fechaBase = masReciente ? '01-01-2000' : '01-01-2050';
        let indice = 0;
        let fechaComparativa = Date.parse(fechaBase);

        for (let i = 0; i < fechas.length; i++) {
            let fecha = Date.parse(fechas[i]);
            if (masReciente && fecha > fechaComparativa) {
                fechaComparativa = fecha;
                indice = i;
            } else if (!masReciente && fecha < fechaComparativa) {
                fechaComparativa = fecha;
                indice = i;
            }
        }
        return dateFormatConDiaShort(fechas[indice]);
    }

    const semanaExtremo = (masReciente) => {
        if (masReciente) {//devuelve la semana fin mas reciente
            let semana = 0;
            for (let i = 0; i < cama.length; i++) if (+cama[i].semana_fin > +semana) semana = cama[i].semana_fin;
            return semana;
        }
        //Devuelve la semana inicio mas antigua
        let semana = 10000;
        for (let i = 0; i < cama.length; i++) if (+cama[i].semana_inicio < +semana) semana = cama[i].semana_inicio;
        return semana;
    }

    const historial = () => {
        if (cama.length === 0) return;
        if (p.historial) p.historial(index + 1);
    }


    return (
        <div className={clase()}
            onClick={historial}
            style={{ width: '130px', height: "130px" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0 text-s'>
                <div className='w-100 text-bold text-l text-center m-0 p-0'>
                    <span className='text-s text-300 me-2'>CAMA</span>
                    {index + 1}
                </div>
                {cama.length > 0 && <>
                    <div className='w-100 text-center text-300 text-s m-0 p-0'>{cama.length} bloque(s)</div>
                    <div className='w-70 text-center m-0 mt-1 p-0 border-bottom border-white m-0 p-0'></div>
                    <div className='text-xs w-100 text-center m-0 m-0 p-0'>{obtenerIndiceFecha(false)}</div>
                    <div className='text-xs w-100 text-center m-0 mb-0 m-0 p-0'>{obtenerIndiceFecha(true)}</div>
                    <div className='w-100 text-center text-bold m-0 mt-1 p-0 text-s m-0 p-0'>{semanaExtremo(false)} - {semanaExtremo(true)}</div>
                </>}

            </div>
        </div>
    )
}

export default ContenedorDeCama;